<template>
  <div class="Square group" v-if="show">
    <div class="Square__Pic cursor-pointer" @click.stop="addFolder">
      <div>
        <div
          class="Square__Inicials !bg-transparent border rounded-md border-gray-400 text-gray-400 | group-hover:text-bc-blue group-hover:border-bc-blue"
        >
          <div class="flex flex-col items-center">
            <aw-icon
              icon="loading"
              class="animate-spin w-6 h-6 md:w-12 md:h-12 leading-tight text-gray-400 | group-hover:text-bc-blue"
            />
            <div
              class="text-sm text-gray-400 text-center | group-hover:text-bc-blue"
            >
              {{ $t('Loading...') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import AddFolder from '../../mixins/AddFolder'

export default {
  mixins: [AddFolder],
  computed: {
    show() {
      return this.bcFolderStore.current?.can_edit
    },
    ...mapStores(useBcSelectedStore, useBcFolderStore)
  }
}
</script>
